<div class="flex flex-col gap-4">
  @if (organisations$ | async; as organisations) {
    <div class="flex flex-row gap-4">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Organisations</mat-label>
        <mat-select multiple [formControl]="organisationsControl">
          @for (organisation of organisations; track trackByOrganisation) {
            <mat-option [value]="organisation">{{
              organisation.name
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button mat-stroked-button (click)="selectAll()">Select All</button>
    </div>
  }

  <div>
    <button
      mat-flat-button
      color="primary"
      [disabled]="isMigrating$ | async"
      (click)="migrate()"
    >
      Migrate
    </button>
  </div>

  <ng-container *ngIf="log$ | async as log">
    <div *ngIf="log.length" class="log-area">
      <div *ngFor="let item of log; trackBy: trackByLog">
        &#91;{{ item.time }}&#93; {{ item.message }}
      </div>
    </div>
  </ng-container>
</div>
